import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CarouselComponent} from './carousel.component';
export class CarouselItemComponent implements OnInit, OnDestroy {
     src;
     link;
     route;
/**
 * @param {?} parent
 */
constructor(private parent: CarouselComponent) {
        parent.addSlideData(this);
    }
/**
 * @return {?}
 */
ngOnInit() {

    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.parent.removeSlide(this);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'pac-item',
    template: `

    `,
    styles: [`

    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CarouselComponent, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'src': [{ type: Input },],
'link': [{ type: Input },],
'route': [{ type: Input },],
};
}

function CarouselItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
CarouselItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CarouselItemComponent.ctorParameters;
/** @type {?} */
CarouselItemComponent.propDecorators;
/** @type {?} */
CarouselItemComponent.prototype.src;
/** @type {?} */
CarouselItemComponent.prototype.link;
/** @type {?} */
CarouselItemComponent.prototype.route;
/** @type {?} */
CarouselItemComponent.prototype.parent;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
